import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface SnackbarData {
  messages: string[];
  type: SnackbarType;
  isHtml?: boolean;
}

type SnackbarType = 'success' | 'error' | 'warning';

@Component({
  selector: 'enx-shared-ui-snackbar',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule],
  templateUrl: './shared-ui-snackbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiSnackbarComponent {
  constructor(
    private snackbarRef: MatSnackBarRef<SharedUiSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
  ) {}

  closeSnackbar(): void {
    this.snackbarRef.dismiss();
  }

  escapeHtml(str: string): string {
    return str.replace(/[&<>"']/g, (char) => {
      const map: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };
      return map[char] || char;
    });
  }
  trackByMessage(index: number, message: string): string {
    return message;
  }
}
